import React from 'react';
import { FRANCE_OUTLINE, FRANCE_OUTLINE_VIEWBOX, FRANCE_OUTLINE_DOM } from './franceOutline';
import './PerimetreMapSkeleton.css';

/**
 * Skeleton de la carte : silhouettes de la France metropolitaine + des DOM (memes
 * formes que la carte), en gris pulsant. Affiche pendant le chargement du chunk
 * geometrie et/ou du referentiel, en edition comme en lecture seule. Les contours
 * sont des assets legers (~17 Ko), independants de la geometrie complete lazy-loadee.
 */
const PerimetreMapSkeleton: React.FC = () => (
  <div className="perimetre-map-skeleton" aria-hidden="true">
    <svg viewBox={FRANCE_OUTLINE_VIEWBOX} className="perimetre-map-skeleton-svg" role="img" aria-label="Chargement de la carte">
      <path d={FRANCE_OUTLINE} className="perimetre-map-skeleton-path" />
    </svg>
    <div className="perimetre-map-skeleton-dom">
      {FRANCE_OUTLINE_DOM.map((dom, i) => (
        <svg key={i} viewBox={dom.viewBox} className="perimetre-map-skeleton-dom-svg">
          <path d={dom.d} className="perimetre-map-skeleton-path" />
        </svg>
      ))}
    </div>
  </div>
);

export default PerimetreMapSkeleton;
